export const SIGNUP_REGISTER_API_PATH = '/api/signup/register';
